(function () {
  var links = document.querySelectorAll(
    '.hp-wizard-hero__badge[href^="#"], .hp-wizard-certificate__button[href^="#"], .raffle-lp-appbar__cta[href^="#"], .raffle-lp-certificate__button[href^="#"], .raffle-lp-cta__button[href^="#"]'
  );
  if (!links.length) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function resolveTarget(href) {
    if (!href || href === '#') return null;

    var target = document.querySelector(href);
    if (target) return target;

    if (href === '#hp-wizard-waitlist') {
      return document.querySelector('[id^="hp-wizard-waitlist-"]');
    }

    if (href === '#raffle-lp-signup') {
      return document.getElementById('raffle-lp-signup');
    }

    return null;
  }

  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      var href = link.getAttribute('href');
      var target = resolveTarget(href);
      if (!target) return;

      event.preventDefault();

      target.scrollIntoView({
        behavior: reducedMotion ? 'auto' : 'smooth',
        block: 'start'
      });

      if (history.replaceState) {
        history.replaceState(null, '', href);
      } else {
        location.hash = href;
      }
    });
  });
})();
